/**
 * Pro vybrany element povoli prvni kliknuti a pak zablokuje vsecha dalsi po dobu uvedenou v parametry
 */
export default function () {
	let elements = document.querySelectorAll('[data-prevent-multiple-click]');

	elements.forEach(function (element) {
		let timeout = element.dataset.preventMultipleClick;
		if (isNaN(timeout)) {
			console.error('timeout number is missing for element: ', element);
			return;
		}
		element.addEventListener('click', (event) => {
			// Zamezí opakovanému kliknutí tím, že dočasně deaktivuje odkaz
			if (event.target.dataset.disabled === 'true') {
				event.preventDefault();
				event.stopPropagation();

				return;
			}

			event.target.dataset.disabled = true;
			setTimeout(() => {
				delete event.target.dataset.disabled;
			}, timeout);
		});
	});
}
